import styled from 'styled-components/macro';
import { BLUE_COLOR_6 } from 'shared/constants/colors';

export const TabContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  background-color: white;
`;

type TTabProps = {
  isActive?: boolean;
};
export const Tab = styled.div<TTabProps>`
  color: ${({ isActive }) => (isActive ? BLUE_COLOR_6 : '#696969')};
  border-bottom: ${({ isActive }) =>
    isActive ? `1px solid ${BLUE_COLOR_6}` : '1px solid white'};
  display: flex;
  align-items: center;
  width: 100%;
  padding: 15px 25px;
`;

export const Title = styled.div`
  margin-left: 5px;
`;
